import { createSlice } from '@reduxjs/toolkit';
import { logout } from './authSlice';

const initialState = {
    active: null,
    selectedCompanyRuc: null,
};

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setActiveOrder: (state, action) => {
            state.active = action.payload;
        },
        clearActiveOrder: (state) => {
            state.active = null;
        },
        setSelectedCompany: (state, action) => {
            state.selectedCompanyRuc = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, (state) => {
            state.active = null;
            state.selectedCompanyRuc = null;
        });
    },
});

export const { setActiveOrder, clearActiveOrder, setSelectedCompany } = orderSlice.actions;

export default orderSlice.reducer;
